import React, { useState } from "react";

import Button from "../Button/Button";

import "./NoseworkJudgeBooksFilterModal.scss";

interface IProps {
  onDownload: (sortOrder: "run_order" | "placement") => void;
  onCancel: () => void;
  hasIncompleteResults?: boolean;
}

const NoseworkJudgeBooksFilterModal: React.FC<IProps> = (props) => {
  const [sortOrder, setSortOrder] = useState<"run_order" | "placement">("placement");

  return (
    <div className="nosework-judge-books-filter-modal">
      <h2>Judge's Books Sort Order</h2>
      <p>Choose how entries are ordered in the printed judge's books.</p>

      {props.hasIncompleteResults && (
        <div className="warning-banner">
          Not all results have been entered. Some entries may be missing from the judge's book.
        </div>
      )}

      <div className="sort-options">
        <div
          className={`sort-option ${sortOrder === "run_order" ? "selected" : ""}`}
          onClick={() => setSortOrder("run_order")}
        >
          <input
            type="radio"
            id="sortRunOrder"
            name="sortOrder"
            checked={sortOrder === "run_order"}
            onChange={() => setSortOrder("run_order")}
          />
          <div className="option-content">
            <div className="option-title">Run Order (Armband Number)</div>
            <div className="option-description">Entries listed in the order they ran, by armband number</div>
          </div>
        </div>

        <div
          className={`sort-option ${sortOrder === "placement" ? "selected" : ""}`}
          onClick={() => setSortOrder("placement")}
        >
          <input
            type="radio"
            id="sortPlacement"
            name="sortOrder"
            checked={sortOrder === "placement"}
            onChange={() => setSortOrder("placement")}
          />
          <div className="option-content">
            <div className="option-title">Placement (Best Score First)</div>
            <div className="option-description">Entries listed by performance — fewest faults and fastest time first</div>
          </div>
        </div>
      </div>

      <div className="modal-actions">
        <Button className="cancel" onClick={props.onCancel} type="button">Cancel</Button>
        <Button onClick={() => props.onDownload(sortOrder)} type="button">Download</Button>
      </div>
    </div>
  );
};

export default NoseworkJudgeBooksFilterModal;
